<template>
	<div data-tour-scope="setting-products">
		<v-main>
			<v-container fluid class="sp-page">
				<v-btn outlined color="primary" class="mb-4" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

				<v-row class="sp-row">
					<!-- ricarico prezzi per marketplace -->
					<v-col cols="12" md="5">
						<SectionCard :title="$vuetify.lang.t('$vuetify.front.subsetting.percentage')" icon="mdi-percent-outline" data-tour="percentage" class="sp-card">
							<div class="sp-hint mb-2">Aumento in % applicato al prezzo del prodotto su ogni canale.</div>
							<div class="sp-lines">
								<div v-for="(item, index) of rules" :key="index" class="sp-line">
									<span class="sp-line-name">
										<v-avatar v-if="item.scope !== 'internal'" size="22px" tile class="mr-2">
											<img v-if="item.scope === 'amazon'" :src="require('@/assets/images/marketplace/Amazon.svg')" alt="Amazon" />
											<img v-else-if="item.scope === 'ebay'" :src="require('@/assets/images/marketplace/Ebay.svg')" alt="eBay" />
										</v-avatar>
										<v-icon v-else small class="mr-2">mdi-storefront-outline</v-icon>
										{{ item.scope === 'internal' ? 'Default' : item.scope === 'amazon' ? 'Amazon' : item.scope === 'ebay' ? 'eBay' : item.scope }}
									</span>
									<v-text-field v-model="item.value" type="number" suffix="%" dense outlined hide-details class="sp-perc"></v-text-field>
								</div>
								<div v-if="!rules || rules.length === 0" class="sp-hint pa-3">Nessun elemento</div>
							</div>
							<div class="sp-actions mt-3">
								<v-btn small depressed color="primary" @click="updateRules"><v-icon left small>mdi-content-save-outline</v-icon>Salva</v-btn>
							</div>
						</SectionCard>
					</v-col>

					<!-- codice a barre -->
					<v-col cols="12" md="7">
						<SectionCard :title="$vuetify.lang.t('$vuetify.front.items.barcode')" icon="mdi-barcode" class="sp-card">
							<div class="sp-grid">
								<v-select v-model="formbarcode.code" :items="barcodes" item-text="value" item-value="id" label="Tipo" dense outlined hide-details="auto"></v-select>
								<v-text-field v-model="formbarcode.test" :error-messages="messagesCode" label="Testo di prova" dense outlined hide-details="auto"></v-text-field>
								<v-text-field v-model="formbarcode.width" label="Larghezza" dense outlined hide-details="auto"></v-text-field>
								<v-text-field v-model="formbarcode.height" label="Altezza" dense outlined hide-details="auto"></v-text-field>
							</div>
							<div class="sp-barcode mt-3">
								<img v-if="image" :src="image" alt="Anteprima codice a barre" />
								<span v-else class="sp-hint">Premi «Prova» per vedere il codice generato</span>
							</div>
							<div class="sp-actions mt-3">
								<v-btn small outlined color="primary" @click="testCode"><v-icon left small>mdi-eye-outline</v-icon>Prova</v-btn>
								<v-spacer></v-spacer>
								<v-btn small depressed color="primary" @click="saveConfigBarcode"><v-icon left small>mdi-content-save-outline</v-icon>Salva configurazione</v-btn>
							</div>
						</SectionCard>
					</v-col>
				</v-row>

				<!-- testi composti da voci ordinate -->
				<v-row class="sp-row">
					<v-col cols="12" md="4" data-tour="slug">
						<OrdineCampiCard
							:title="$vuetify.lang.t('$vuetify.front.items.slug')"
							icon="mdi-link-variant"
							descrizione="Le voci accese, in quest'ordine, formano l'indirizzo della pagina prodotto."
							:items="getSettings.slug || []"
							fisso="name"
							:anteprima="slugText"
							@drop="updateDrop"
							@change-status="changeStatusSlug()"
						>
							<template v-slot:azioni>
								<v-btn small outlined color="primary" @click="reIndexSlug"><v-icon left small>mdi-refresh</v-icon>Ricrea slug per tutti i prodotti</v-btn>
							</template>
						</OrdineCampiCard>
					</v-col>
					<v-col cols="12" md="4" data-tour="sku">
						<OrdineCampiCard
							:title="$vuetify.lang.t('$vuetify.front.items.sku')"
							icon="mdi-identifier"
							descrizione="Le voci accese, in quest'ordine, formano lo SKU dei nuovi prodotti."
							:items="getSettings.sku || []"
							fisso="increment"
							:anteprima="skuText"
							@drop="updateDropSku"
							@change-status="changeStatusSku()"
						>
							<div v-if="getSettings.settingsku" class="sp-grid mt-3">
								<v-text-field v-model="getSettings.settingsku.letter" type="number" label="Lettere per voce" dense outlined hide-details="auto" @input="composeTextSku()"></v-text-field>
								<v-text-field v-model="getSettings.settingsku.separator" label="Separatore" dense outlined hide-details="auto" @input="composeTextSku()"></v-text-field>
							</div>
							<template v-slot:azioni>
								<v-spacer></v-spacer>
								<v-btn small depressed color="primary" @click="saveConfigSku"><v-icon left small>mdi-content-save-outline</v-icon>Salva configurazione</v-btn>
							</template>
						</OrdineCampiCard>
					</v-col>
					<v-col cols="12" md="4">
						<OrdineCampiCard
							:title="$vuetify.lang.t('$vuetify.front.items.etichetta')"
							icon="mdi-label-outline"
							descrizione="Le voci accese, in quest'ordine, formano il testo dell'etichetta."
							:items="getSettings.etichetta || []"
							fisso="name"
							:anteprima="slugTextEtichetta"
							@drop="updateDropEtichetta"
							@change-status="changeStatusEtichetta()"
						/>
					</v-col>
				</v-row>

				<!-- opzioni semplici -->
				<v-row class="sp-row">
					<v-col cols="12" md="4">
						<SectionCard :title="$vuetify.lang.t('$vuetify.front.items.giacenze')" icon="mdi-warehouse" data-tour="stock" class="sp-card">
							<div class="sp-hint mb-3">{{ $vuetify.lang.t('$vuetify.front.items.gestionegiacenze') }}</div>
							<v-select v-model="formstock.stock" :items="status" item-text="text" item-value="value" label="Status" dense outlined hide-details></v-select>
							<div class="sp-actions mt-3">
								<v-btn small depressed color="primary" @click="saveStock"><v-icon left small>mdi-content-save-outline</v-icon>Salva</v-btn>
							</div>
						</SectionCard>
					</v-col>
					<v-col cols="12" md="4">
						<SectionCard :title="$vuetify.lang.t('$vuetify.front.items.riarrange')" icon="mdi-sort" data-tour="riarrange" class="sp-card">
							<div class="sp-switch">
								<span class="sp-hint">{{ $vuetify.lang.t('$vuetify.front.items.handlerriarrange') }}</span>
								<v-switch v-model="formriarrange.riarrange" color="primary" class="mt-0 pt-0" hide-details></v-switch>
							</div>
							<div class="sp-actions mt-3">
								<v-btn small depressed color="primary" @click="saveRiarrange"><v-icon left small>mdi-content-save-outline</v-icon>Salva</v-btn>
							</div>
						</SectionCard>
					</v-col>
					<v-col cols="12" md="4">
						<SectionCard :title="$vuetify.lang.t('$vuetify.front.items.restricted')" icon="mdi-shield-lock-outline" class="sp-card">
							<div class="sp-switch">
								<span class="sp-hint">{{ $vuetify.lang.t('$vuetify.front.items.handlerrestricted') }}</span>
								<v-switch v-model="formrestricted.restricted" color="primary" class="mt-0 pt-0" hide-details></v-switch>
							</div>
							<div class="sp-actions mt-3">
								<v-btn small depressed color="primary" @click="saveRestriceted"><v-icon left small>mdi-content-save-outline</v-icon>Salva</v-btn>
							</div>
						</SectionCard>
					</v-col>
				</v-row>

				<v-row class="sp-row">
					<v-col cols="12">
						<product-options />
					</v-col>
				</v-row>
				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
					{{ snackbar.text }}
					<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
				</v-snackbar>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<!--<v-card-text>Eliminando la categoria non potrai più ripristinarla. I prodotti associati resteranno senza
            categoria
        </v-card-text>-->

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmSlug" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando questa operazione lo slug dei prodotti verranno modificati </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmSlug = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmReindexSlug"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogToTranslate" max-width="800">
			<v-card>
				<v-card-title class="headline"></v-card-title>
				<v-card-text>
					<v-row v-for="(detail, index) in itemToTranslate.trans" :key="index">
						<v-col cols="1" :style="'display:flex;align-items:center;justify-content:center;cursor:pointer;'">
							<v-avatar size="25px" tile class="mr-2" @click="traduci(detail.name, detail.lang, index)" title="Translate">
								<img v-if="detail.lang === 'it'" :src="require('@/assets/images/flag/IT.svg')" alt="it" />
								<img v-else-if="detail.lang === 'en'" :src="require('@/assets/images/flag/GB.svg')" alt="en" />
								<img v-else-if="detail.lang === 'de'" :src="require('@/assets/images/flag/DE.svg')" alt="de" />
								<img v-else-if="detail.lang === 'fr'" :src="require('@/assets/images/flag/FR.svg')" alt="fr" />
								<img v-else-if="detail.lang === 'es'" :src="require('@/assets/images/flag/ES.svg')" alt="es" />
							</v-avatar>
							<v-avatar size="24px" tile class="ml-2" @click="traduci(detail.name, detail.lang, index)" title="Translate">
								<v-img :src="require('@/assets/images/Google_Translate_logo.svg')" />
							</v-avatar>
						</v-col>
						<v-col cols="11">
							<v-text-field hide-details="auto" :label="detail.lang" v-model="detail.name"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogToTranslate = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmTranslate"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @message="propSetMessages"></FormCreate>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createProductsSettingsTourSteps } from './products-settings-tour';
import { ObjectID } from 'bson';
import SectionCard from '@/components/core/SectionCard.vue';
import OrdineCampiCard from './components/OrdineCampiCard.vue';

import { slugify } from '../../Helper';
const FormCreate = () => import('@/components/conditions/Create.vue');
const ProductOptions = () => import('@/components/product_options/Index.vue');
export default {
	name: 'Products',
	setup() {
		return { tour: useTour(createProductsSettingsTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			componentKey: 0,
			rules: [],
			items: [],
			setinterval: '',
			operation: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					payments: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: false,
			loading: false,
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: 'Lingua', value: '' },
				{ text: 'Status', value: '' },
				{ text: 'Default', value: '' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,
			dialogconfirmSlug: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			form: {
				name: '',
				is_active: '',
			},
			conditions: [],
			languages: [],
			dialogToTranslate: false,
			itemToTranslate: {},
			lang: '',
			tableHeadersFile: [
				{ text: '#', sortable: false },
				{ text: 'Order', value: 'order', sortable: false },
				{ text: 'Status', value: 'status', sortable: false },
				{ text: 'Name', value: 'name', sortable: false },
			],
			slugText: '',
			slugTextEtichetta: '',
			skuText: '',
			barcode: {},
			qrcode: {},
			barcodes: [
				{ id: 'code39', value: 'Code39' },
				{ id: 'auspost', value: 'AusPost 4 State Customer Code' },
				{ id: 'azteccode', value: 'Aztec Code' },
				{ id: 'aztecrune', value: 'Aztec Runes' },
				{ id: 'bc412', value: 'BC412' },
				{ id: 'coop2of5', value: 'COOP 2 of 5' },
				{ id: 'channelcode', value: 'Channel Code' },
				{ id: 'rationalizedCodabar', value: 'Codabar' },
				{ id: 'codablockf', value: 'Codablock' },
				{ id: 'code11', value: 'Code 11' },
				{ id: 'code128', value: 'Code 128' },
				{ id: 'code16k', value: 'Code 16K' },
				{ id: 'code2of5', value: 'Code 25' },
				{ id: 'code39', value: 'Code 39' },
				{ id: 'code39ext', value: 'Code 39 Extended' },
				{ id: 'code49', value: 'Code 49' },
				{ id: 'code93', value: 'Code 93' },
				{ id: 'code93ext', value: 'Code 93 Extended' },
				{ id: 'codeone', value: 'Code One' },
				{ id: 'azteccodecompact', value: 'Compact Aztec Code' },
				{ id: 'pdf417compact', value: 'Compact PDF417' },
				{ id: 'raw', value: 'Custom 1D symbology' },
				{ id: 'datamatrix', value: 'Data Matrix' },
				{ id: 'datamatrixrectangular', value: 'Data Matrix Rectangular' },
				{ id: 'datamatrixrectangularextension', value: 'Data Matrix Rectangular Extension' },
				{ id: 'datalogic2of5', value: 'Datalogic 2 of 5' },
				{ id: 'identcode', value: 'Deutsche Post Identcode' },
				{ id: 'leitcode', value: 'Deutsche Post Leitcode' },
				{ id: 'dotcode', value: 'DotCode' },
				{ id: 'ean13', value: 'EAN-13' },
				{ id: 'ean13composite', value: 'EAN-13 Composite' },
				{ id: 'ean2', value: 'EAN-2 (2 digit addon)' },
				{ id: 'ean5', value: 'EAN-5 (5 digit addon)' },
				{ id: 'ean8', value: 'EAN-8' },
				{ id: 'ean8composite', value: 'EAN-8 Composite' },
				{ id: 'flattermarken', value: 'Flattermarken' },
				{ id: 'gs1-cc', value: 'GS1 Composite 2D Component' },
				{ id: 'gs1datamatrix', value: 'GS1 Data Matrix' },
				{ id: 'gs1datamatrixrectangular', value: 'GS1 Data Matrix Rectangular' },
				{ id: 'databarexpanded', value: 'GS1 DataBar Expanded' },
				{ id: 'databarexpandedcomposite', value: 'GS1 DataBar Expanded Composite' },
				{ id: 'databarexpandedstacked', value: 'GS1 DataBar Expanded Stacked' },
				{ id: 'databarexpandedstackedcomposite', value: 'GS1 DataBar Expanded Stacked Composite' },
				{ id: 'databarlimited', value: 'GS1 DataBar Limited' },
				{ id: 'databarlimitedcomposite', value: 'GS1 DataBar Limited Composite' },
				{ id: 'databaromni', value: 'GS1 DataBar Omnidirectional' },
				{ id: 'databaromnicomposite', value: 'GS1 DataBar Omnidirectional Composite' },
				{ id: 'databarstacked', value: 'GS1 DataBar Stacked' },
				{ id: 'databarstackedcomposite', value: 'GS1 DataBar Stacked Composite' },
				{ id: 'databarstackedomni', value: 'GS1 DataBar Stacked Omnidirectional' },
				{ id: 'databarstackedomnicomposite', value: 'GS1 DataBar Stacked Omnidirectional Composite' },
				{ id: 'databartruncated', value: 'GS1 DataBar Truncated' },
				{ id: 'databartruncatedcomposite', value: 'GS1 DataBar Truncated Composite' },
				{ id: 'gs1dotcode', value: 'GS1 DotCode' },
				{ id: 'gs1northamericancoupon', value: 'GS1 North American Coupon' },
				{ id: 'gs1qrcode', value: 'GS1 QR Code' },
				{ id: 'gs1-128', value: 'GS1-128' },
				{ id: 'gs1-128composite', value: 'GS1-128 Composite' },
				{ id: 'ean14', value: 'GS1-14' },
				{ id: 'hibcazteccode', value: 'HIBC Aztec Code' },
				{ id: 'hibccodablockf', value: 'HIBC Codablock F' },
				{ id: 'hibccode128', value: 'HIBC Code 128' },
				{ id: 'hibccode39', value: 'HIBC Code 39' },
				{ id: 'hibcdatamatrix', value: 'HIBC Data Matrix' },
				{ id: 'hibcdatamatrixrectangular', value: 'HIBC Data Matrix Rectangular' },
				{ id: 'hibcmicropdf417', value: 'HIBC MicroPDF417' },
				{ id: 'hibcpdf417', value: 'HIBC PDF417' },
				{ id: 'hibcqrcode', value: 'HIBC QR Code' },
				{ id: 'hanxin', value: 'Han Xin Code' },
				{ id: 'iata2of5', value: 'IATA 2 of 5' },
				{ id: 'isbn', value: 'ISBN' },
				{ id: 'ismn', value: 'ISMN' },
				{ id: 'issn', value: 'ISSN' },
				{ id: 'itf14', value: 'ITF-14' },
				{ id: 'industrial2of5', value: 'Industrial 2 of 5' },
				{ id: 'interleaved2of5', value: 'Interleaved 2 of 5 (ITF)' },
				{ id: 'code32', value: 'Italian Pharmacode' },
				{ id: 'japanpost', value: 'Japan Post 4 State Customer Code' },
				{ id: 'msi', value: 'MSI Modified Plessey' },
				{ id: 'matrix2of5', value: 'Matrix 2 of 5' },
				{ id: 'maxicode', value: 'MaxiCode' },
				{ id: 'microqrcode', value: 'Micro QR Code' },
				{ id: 'micropdf417', value: 'MicroPDF417' },
				{ id: 'symbol', value: 'Miscellaneous symbols' },
				{ id: 'pdf417', value: 'PDF417' },
				{ id: 'pharmacode', value: 'Pharmaceutical Binary Code' },
				{ id: 'pzn', value: 'Pharmazentralnummer (PZN)' },
				{ id: 'plessey', value: 'Plessey UK' },
				{ id: 'posicode', value: 'PosiCode' },
				{ id: 'qrcode', value: 'QR Code' },
				{ id: 'rectangularmicroqrcode', value: 'Rectangular Micro QR Code' },
				{ id: 'kix', value: 'Royal Dutch TPG Post KIX' },
				{ id: 'royalmail', value: 'Royal Mail 4 State Customer Code' },
				{ id: 'mailmark', value: 'Royal Mail Mailmark' },
				{ id: 'sscc18', value: 'SSCC-18' },
				{ id: 'swissqrcode', value: 'Swiss QR Code' },
				{ id: 'telepen', value: 'Telepen' },
				{ id: 'telepennumeric', value: 'Telepen Numeric' },
				{ id: 'pharmacode2', value: 'Two-track Pharmacode' },
				{ id: 'upca', value: 'UPC-A' },
				{ id: 'upcacomposite', value: 'UPC-A Composite' },
				{ id: 'upce', value: 'UPC-E' },
				{ id: 'upcecomposite', value: 'UPC-E Composite' },
				{ id: 'onecode', value: 'USPS Intelligent Mail' },
				{ id: 'planet', value: 'USPS PLANET' },
				{ id: 'postnet', value: 'USPS POSTNET' },
				{ id: 'ultracode', value: 'Ultracode' },
			],

			formbarcode: {
				code: 'qrcode',
				test: '0123456789',
				width: '800',
				height: '200',
			},
			formstock: {
				stock: '',
			},
			formriarrange: {
				riarrange: false,
			},
			formrestricted: {
				restricted: false,
			},
			messagesCode: '',
			image: '',
			status: [],
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},

	/*  code: 'code128',
  data: "0123456789",
  width: 3,
  height: 10,*/
	async created() {
		this.setPreload(true);
		await this.fetchSettings();

		this.composeTextSlug();
		this.composeTextEtichetta();
		this.composeTextSku();

		if (this.getSettings.barcode) {
			this.formbarcode.code = this.getSettings.barcode.code ? this.getSettings.barcode.code : 'qrcode';
			this.formbarcode.width = this.getSettings.barcode.width ? this.getSettings.barcode.width : '800';
			this.formbarcode.height = this.getSettings.barcode.height ? this.getSettings.barcode.height : '200';
		}
		this.image = await this.createBarcode(this.formbarcode);

		this.formstock.stock = this.getSettings.stock;
		this.formriarrange.riarrange = this.getSettings.riarrange;

		if (this.image.error) {
			this.messagesCode = this.image.error;
			this.snackbar.color = 'error';
			this.snackbar.text = this.image.error;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.image = '';
		}

		let amazon = _.find(this.getSettings.settings, { service: 'mws', active: true });
		let ebay = _.find(this.getSettings.settings, { service: 'ebay', active: true });

		if (!this.getSettings.rules || this.getSettings.rules.length === 0) {
			this.rules.push({ typology: 'increment', scope: 'internal', value: 0 });

			if (amazon) {
				this.rules.push({ typology: 'increment', scope: 'amazon', value: 0 });
			}
			if (ebay) {
				this.rules.push({ typology: 'increment', scope: 'ebay', value: 0 });
			}
		} else {
			let check_internal = _.find(this.getSettings.rules, { scope: 'internal' });
			if (!check_internal) {
				this.rules.push({ typology: 'increment', scope: 'internal', value: 0 });
			} else {
				this.rules.push(check_internal);
			}

			let check_amazon = _.find(this.getSettings.rules, { scope: 'amazon' });
			if (!check_amazon) {
				this.rules.push({ typology: 'increment', scope: 'amazon', value: 0 });
			} else {
				this.rules.push(check_amazon);
			}

			let check_ebay = _.find(this.getSettings.rules, { scope: 'ebay' });
			if (!check_ebay) {
				this.rules.push({ typology: 'increment', scope: 'ebay', value: 0 });
			} else {
				this.rules.push(check_ebay);
			}
		}

		if (this.getSettings.condition !== undefined) {
			_.forEach(this.getSettings.condition, cond => {
				this.conditions.push(cond);
			});
		}

		if (this.getSettings.languages !== undefined) {
			_.forEach(this.getSettings.languages, lang => {
				if (lang.is_active) {
					this.languages.push(lang.lang);
					if (lang.default) {
						this.lang = lang.lang;
					}
				}
			});
		}

		this.fetchStatusOrder().then(result => {
			this.status.push({ text: 'Mai', value: '' });
			_.forEach(result.data, el => {
				var textStatus = _.find(el.trans, { lang: this.getLanguage });

				this.status.push({ text: textStatus.value, value: el._id });
			});
		});

		if (this.getSettings.rules !== undefined) {
			var rules = _.filter(this.getSettings.rules, { typology: 'increment' });
			_.forEach(rules, rule => {
				var check = _.find(this.rules, { scope: rule.scope });
				if (check) {
					check.value = rule.value;
				}
			});
		}

		this.setPreload(false);
		this.selectedchecbox = [];
	},

	watch: {
		settings: {},
	},
	components: {
		TourOverlay,
		FormCreate,
		ProductOptions,
		SectionCard,
		OrdineCampiCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getLanguage: 'profile/getLanguage',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
	},

	methods: {
		// card slug/sku/etichetta: la posizione e' l'unica colonna in sola lettura oltre al nome
		campiOrdine(index) {
			return [{ label: 'Posizione', value: index + 1 }];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchStatusOrder: 'statusorders/fetchLists',
			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			createBarcode: 'barcode/createBarcode',

			//'resetMessages' : 'settings/resetMessages'
		}),
		async testCode() {
			this.image = await this.createBarcode(this.formbarcode);
			//console.log(this.image.error)
			if (this.image.error) {
				this.messagesCode = this.image.error;
				this.snackbar.color = 'error';
				this.snackbar.text = this.image.error;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.image = '';
				//        this.image=''
			} else {
				this.messagesCode = '';
			}
		},
		async composeTextSlug() {
			var clone = JSON.parse(JSON.stringify(this.getSettings.slug || []));
			this.slugText = _.join(_.map(_.filter(clone, { active: true }), 'key'), ' - ');
		},
		async composeTextEtichetta() {
			var clone = JSON.parse(JSON.stringify(this.getSettings.etichetta || []));
			this.slugTextEtichetta = _.join(_.map(_.filter(clone, { active: true }), 'key'), ' - ');
		},
		async composeTextSku() {
			var clone = JSON.parse(JSON.stringify(this.getSettings.sku || []));

			// profili nati senza impostazioni SKU: niente progressivo e valori di base, la pagina non deve rompersi
			const settingsku = this.getSettings.settingsku || { increment: 1, separator: '', letter: 2 };
			var increment = _.find(clone, { key: 'increment' });
			if (increment) {
				increment.key = settingsku.increment;
			}

			for await (let el of clone) {
				var str = await slugify(el.key, '');

				str = str.toUpperCase();

				str = str.slice(0, +settingsku.letter);
				el.key = str;
			}

			this.skuText = _.join(_.map(_.filter(clone, { active: true }), 'key'), settingsku.separator);
		},
		async updateDropSku(dropResult) {
			this.oldValue = this.getSettings.sku[dropResult.moved.oldIndex];
			this.newValue = this.getSettings.sku[dropResult.moved.newIndex];

			this.getSettings.sku.splice(dropResult.moved.oldIndex, 1);
			this.getSettings.sku.splice(dropResult.moved.newIndex, 0, this.oldValue);

			await this.setPreload(true);
			await this.updateSku();
			this.composeTextSku();
			//this.form.values[dropResult.moved.newIndex]=this.oldValue
			//this.form.values[dropResult.moved.oldIndex]=this.newValue
		},
		async updateDrop(dropResult) {
			this.oldValue = this.getSettings.slug[dropResult.moved.oldIndex];
			this.newValue = this.getSettings.slug[dropResult.moved.newIndex];

			this.getSettings.slug.splice(dropResult.moved.oldIndex, 1);
			this.getSettings.slug.splice(dropResult.moved.newIndex, 0, this.oldValue);

			await this.setPreload(true);
			await this.updateSlug();
			this.composeTextSlug();
			//this.form.values[dropResult.moved.newIndex]=this.oldValue
			//this.form.values[dropResult.moved.oldIndex]=this.newValue
		},
		async updateDropEtichetta(dropResult) {
			this.oldValue = this.getSettings.etichetta[dropResult.moved.oldIndex];
			this.newValue = this.getSettings.etichetta[dropResult.moved.newIndex];

			this.getSettings.etichetta.splice(dropResult.moved.oldIndex, 1);
			this.getSettings.etichetta.splice(dropResult.moved.newIndex, 0, this.oldValue);

			await this.setPreload(true);
			await this.updateSlugEtichetta();
			this.composeTextEtichetta();
		},
		propSetMessages(text) {
			this.conditions = this.getSettings.condition;
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		async translateItem(item) {
			this.dialogToTranslate = true;
			this.itemToTranslate = { ...item };
		},

		async confirmTranslate() {
			await this.setPreload(true);
			this.dialogToTranslate = false;
			var change = _.find(this.conditions, { _id: this.itemToTranslate._id });
			_.assignIn(change, this.itemToTranslate);
			await this.updateConditions();
		},
		async changeStatusSlug() {
			await this.setPreload(true);
			await this.updateSlug();
			this.composeTextSlug();
		},
		async saveConfigBarcode() {
			await this.setPreload(true);
			await this.updateSettingBarcode();
			//this.composeTextSlug();
		},
		async saveStock() {
			await this.setPreload(true);
			await this.updateSettingStock();
			//this.composeTextSlug();
		},
		async saveRiarrange() {
			await this.setPreload(true);
			await this.updateSettingRiarrange();
			//this.composeTextSlug();
		},
		async saveRestriceted() {
			await this.setPreload(true);
			await this.updateSettingRestricted();
			//this.composeTextSlug();
		},
		async saveConfigSku() {
			await this.setPreload(true);
			await this.updateSettingSku();
			//this.composeTextSlug();
		},
		async changeStatusSku() {
			await this.setPreload(true);
			await this.updateSku();
			this.composeTextSku();
		},
		async changeStatusEtichetta() {
			await this.setPreload(true);
			await this.updateEtichetta();
			this.composeTextEtichetta();
		},
		async changeStatus() {
			await this.setPreload(true);
			await this.updateConditions();
		},
		async reIndexSlug() {
			this.dialogconfirmSlug = true;
			//await this.setPreload(true)
		},
		async changeDefault(_id) {
			await this.setPreload(true);
			_.forEach(this.conditions, cond => {
				cond.default = cond._id === _id;
			});
			await this.updateConditions();
		},
		async confirmReindexSlug() {
			this.dialogconfirmSlug = false;
			await this.setPreload(true);
			let url = 'items/reindexslug';
			axios
				.post(`${this.getUrl}${url}`, this.getSettings.slug, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					await this.setPreload(false);

					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo in pochi minuti';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					this.form.name = '';
					this.form.is_active = false;
				})
				.catch(err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async addValue() {
			this.dialogconfirm = false;
			await this.setPreload(true);

			if (this.form.name !== '') {
				var trans = [];
				_.forEach(this.languages, lang => {
					trans.push({ lang: lang, name: this.form.name });
				});
				var _id = new ObjectID();

				this.conditions.push({ trans: trans, is_active: this.form.is_active, is_default: false, _id: _.toString(_id) });

				let url = 'profile/conditions';
				axios
					.post(`${this.getUrl}${url}`, this.conditions, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(async ({ data }) => {
						await this.setPreload(false);

						this.setSettings(data.data);
						this.preload = false;
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con  successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;

						this.form.name = '';
						this.form.is_active = false;
					})
					.catch(err => {
						this.setPreload(false);
						if (err.response) {
							let errors = err.response.data.error;
							if (errors) {
								if (_.isArray(errors)) {
									errors.forEach(value => {
										//console.log(value.msg);
										this.messages[value.param] = value.msg;
									});
								} else {
									err.message = errors;
								}
							}

							this.snackbar.color = 'error';
							this.snackbar.text = err.message;
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
							this.preload = false;
							if (err.response.status === 401) {
								this.setLogout();
								this.$router.push('/login');
							}
						}
					});
			}
		},
		async updateSettingBarcode() {
			await this.setPreload(true);
			let url = 'profile/barcode';
			axios
				.post(`${this.getUrl}${url}`, this.formbarcode, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					await this.setPreload(false);
					this.setSettings(data.data);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSettingStock() {
			await this.setPreload(true);
			let url = 'profile/stock';
			axios
				.post(`${this.getUrl}${url}`, this.formstock, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					await this.setPreload(false);
					this.setSettings(data.data);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSettingRestricted() {
			await this.setPreload(true);
			let url = 'profile/restricted';
			axios
				.post(`${this.getUrl}${url}`, this.formrestricted, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					await this.setPreload(false);
					this.setSettings(data.data);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSettingRiarrange() {
			await this.setPreload(true);
			let url = 'profile/riarrange';
			axios
				.post(`${this.getUrl}${url}`, this.formriarrange, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					await this.setPreload(false);
					this.setSettings(data.data);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSettingSku() {
			await this.setPreload(true);
			let url = 'profile/settingsku';
			axios
				.post(`${this.getUrl}${url}`, this.getSettings.settingsku, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					this.setSettings(data.data);
					await this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSlugEtichetta() {
			await this.setPreload(true);
			let url = 'profile/etichetta';
			axios
				.post(`${this.getUrl}${url}`, this.getSettings.etichetta, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					//console.dir(data.data, { depth: 10 });
					this.setSettings(data.data);
					await this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSlug() {
			await this.setPreload(true);
			let url = 'profile/slug';
			axios
				.post(`${this.getUrl}${url}`, this.getSettings.slug, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					this.setSettings(data.data);
					await this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateSku() {
			await this.setPreload(true);
			let url = 'profile/sku';
			axios
				.post(`${this.getUrl}${url}`, this.getSettings.sku, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					this.setSettings(data.data);
					await this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateEtichetta() {
			await this.setPreload(true);
			let url = 'profile/etichetta';
			axios
				.post(`${this.getUrl}${url}`, this.getSettings.etichetta, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					this.setSettings(data.data);
					await this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async updateConditions() {
			await this.setPreload(true);
			let url = 'profile/conditions';
			axios
				.post(`${this.getUrl}${url}`, this.conditions, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					this.setSettings(data.data);
					await this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(async err => {
					await this.setPreload(false);
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		confirmDelete() {
			this.dialogconfirm = false;
			this.preload = true;

			_.forEach(this.selectedchecbox, c => {
				this.conditions = _.filter(this.conditions, r => {
					return r._id !== c;
				});
			});

			this.selectedchecbox = [];

			let url = 'profile/conditions';
			axios
				.post(`${this.getUrl}${url}`, this.conditions, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		updateRules() {
			this.preload = true;

			_.forEach(this.rules, rule => {
				if (!(rule.value >= 0)) {
					this.snackbar.color = 'error';
					this.snackbar.text = '% deve essere >= 0';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.preload = false;
				}
			});

			let url = 'profile/rules';
			axios
				.post(
					`${this.getUrl}${url}`,
					{
						data: this.rules,
						typology: 'increment',
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(({ data }) => {
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggle() {
			if (!this.selectedall) {
				this.selectedchecbox = [];
			} else {
				//console.log(this.selected[0])

				this.selectedchecbox = [];
				_.forEach(this.conditions, cond => {
					if (!cond.default) {
						this.selectedchecbox.push(cond._id);
					}
				});
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},

		resetForm() {
			this.form.size = '';
		},

		checkpresenza(item) {
			return this.selected.includes(item);
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		traduciAll(id) {
			_.forEach(this.conditions[id].trans, tran => {
				if (!_.isEmpty(tran.name)) {
					let datapost = {
						target: tran.lang,
						words: {
							name: tran.name,
						},
					};
					axios
						.post(`${this.getUrl}translates`, { data: datapost }, { headers: { Authorization: `Bearer ${this.getToken}` } })

						.then(res => {
							tran.name = res.data.data[0];
						})
						.catch(err => {
							console.log(err);
						});
				}
			});
		},
		async traduci(text, lang, index) {
			await this.setPreload(true);
			var datapost = {
				target: lang,
				words: {
					title: text,
				},
			};
			axios
				.post(`${this.getUrl}translates`, { data: datapost }, { headers: { Authorization: `Bearer ${this.getToken}` } })

				.then(async res => {
					this.itemToTranslate.trans[index].name = res.data.data[0];
					await this.setPreload(false);
				})
				.catch(async err => {
					await this.setPreload(false);
					console.log(err);
				});
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		extension(item) {
			var prova = this.selected.includes(item);

			if (!prova) {
				this.selected.push(item);
			} else {
				var indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
			//console.log(this.selected)
		},
		copia(id) {
			var master = this.conditions[id].trans[0].name;

			_.forEach(this.conditions[id].trans, trans => {
				if (_.isEmpty(trans.name)) {
					trans.name = master;
				}
			});
		},
	},
};
</script>

<style></style>

<style scoped>
/* pagina a card: 16px tra le card come nelle schede */
.sp-row {
	margin-top: 0;
	margin-bottom: 0;
}
.sp-row > [class*='col'] {
	padding-top: 0;
	padding-bottom: 16px;
}
.sp-card {
	height: 100%;
}
.sp-hint {
	font-size: 12px;
	color: #5f6b7a;
}
.sp-grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 12px 16px;
}
.sp-lines {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.sp-line {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 6px 12px;
	font-size: 14px;
}
.sp-line + .sp-line {
	border-top: 1px solid #eef2f7;
}
.sp-line-name {
	display: inline-flex;
	align-items: center;
	font-weight: 500;
}
.sp-perc {
	flex: 0 0 120px;
	max-width: 120px;
}
.sp-barcode {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 110px;
	background: #f3f6fa;
	border: 1px dashed #c9d4e2;
	border-radius: 8px;
	padding: 10px;
	overflow: auto;
}
.sp-barcode img {
	max-width: 100%;
	background: #fff;
}
.sp-switch {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}
.sp-actions {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	justify-content: flex-end;
}
@media (max-width: 600px) {
	.sp-grid {
		grid-template-columns: 1fr;
	}
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.settings-product-cards,
.settings-product-cards tr {
	display: block;
	width: 100%;
}
.settings-product-cards tr,
.settings-product-cards tr:hover {
	background: transparent !important;
}
.settings-product-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.settings-product-cards tr:first-child td {
	padding-top: 12px !important;
}
.settings-product-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.settings-product-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
